import React from "react";
import PrescriptionListComponent from "@components/User/Prescription/PrescriptionList/PrescriptionList";

export default function PrescriptionList() {
  return <PrescriptionListComponent />;
}
